import { render, staticRenderFns } from "./apply_suggestion.vue.js?vue&type=template&id=4f3ae0e0&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./apply_suggestion.vue?vue&type=template&id=4f3ae0e0&vue3"
import script from "./apply_suggestion.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./apply_suggestion.vue?vue&type=script&lang=js&vue3"
export * from "./apply_suggestion.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./apply_suggestion.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports